import React from 'react';
import { ChevronDown } from 'lucide-react';

const Hero = ({ scrollY }) => {
  const parallaxOffset = scrollY * 0.5;

  return (
    <section 
      className="relative min-h-screen flex items-center justify-center overflow-hidden"
      data-component-path="client/src/components/Hero.jsx"
      data-component-line="1:5"
      data-component-id="client/src/components/Hero.jsx:1:5"
    >
      {/* Abstract terrain texture background */}
      <div 
        className="absolute inset-0 opacity-20"
        style={{ transform: `translateY(${parallaxOffset}px)` }}
        data-component-path="client/src/components/Hero.jsx"
        data-component-line="2:7"
        data-component-id="client/src/components/Hero.jsx:2:7"
      >
        <div 
          className="absolute inset-0 bg-gradient-to-b from-slate-900 via-slate-800 to-slate-950"
          data-component-path="client/src/components/Hero.jsx"
          data-component-line="3:9"
          data-component-id="client/src/components/Hero.jsx:3:9"
        ></div>
        <div 
          className="absolute inset-0"
          style={{
            backgroundImage: `url("data:image/svg+xml,%3Csvg width='60' height='60' viewBox='0 0 60 60' xmlns='http://www.w3.org/2000/svg'%3E%3Cg fill='none' fill-rule='evenodd'%3E%3Cg fill='%23ffffff' fill-opacity='0.05'%3E%3Cpath d='M36 34v-4h-2v4h-4v2h4v4h2v-4h4v-2h-4zm0-30V0h-2v4h-4v2h4v4h2V6h4V4h-4zM6 34v-4H4v4H0v2h4v4h2v-4h4v-2H6zM6 4V0H4v4H0v2h4v4h2V6h4V4H6z'/%3E%3C/g%3E%3C/g%3E%3C/svg%3E")`,
          }}
          data-component-path="client/src/components/Hero.jsx"
          data-component-line="4:9"
          data-component-id="client/src/components/Hero.jsx:4:9"
        ></div>
      </div>

      {/* Gradient overlay */}
      <div 
        className="absolute inset-0 bg-gradient-to-b from-transparent via-slate-950/50 to-slate-950"
        data-component-path="client/src/components/Hero.jsx"
        data-component-line="5:7"
        data-component-id="client/src/components/Hero.jsx:5:7"
      ></div>

      {/* Content */}
      <div 
        className="relative z-10 text-center px-6 max-w-5xl mx-auto"
        data-component-path="client/src/components/Hero.jsx"
        data-component-line="6:7"
        data-component-id="client/src/components/Hero.jsx:6:7"
      >
        <div 
          className="animate-fade-in"
          data-component-path="client/src/components/Hero.jsx"
          data-component-line="7:9"
          data-component-id="client/src/components/Hero.jsx:7:9"
        >
          {/* Brand name */}
          <h1 
            className="text-6xl md:text-8xl lg:text-9xl font-black tracking-tighter mb-8 text-slate-100"
            style={{ 
              fontFamily: 'Inter, sans-serif',
              letterSpacing: '-0.05em',
              textShadow: '0 0 80px rgba(148, 163, 184, 0.3)'
            }}
            data-component-path="client/src/components/Hero.jsx"
            data-component-line="8:11"
            data-component-id="client/src/components/Hero.jsx:8:11"
          >
            grYp Gear
          </h1>

          {/* Cryptic tagline */}
          <p 
            className="text-xl md:text-2xl lg:text-3xl font-light text-slate-400 mb-12 tracking-wide"
            data-component-path="client/src/components/Hero.jsx"
            data-component-line="9:11"
            data-component-id="client/src/components/Hero.jsx:9:11"
          >
            Feel what you've been missing.
          </p>

          {/* CTA */}
          <a 
            href="#notify"
            className="inline-flex items-center justify-center gap-2 h-14 px-8 bg-slate-100 text-slate-950 font-semibold text-lg rounded-none hover:bg-slate-200 transition-all duration-300 shadow-lg hover:shadow-2xl hover:shadow-slate-500/20 focus:ring-4 focus:ring-slate-400/50"
            data-component-path="client/src/components/Hero.jsx"
            data-component-line="10:11"
            data-component-id="client/src/components/Hero.jsx:10:11"
          >
            Get Notified
          </a>
        </div>

        {/* Scroll indicator */}
        <div 
          className="absolute bottom-12 left-1/2 transform -translate-x-1/2 animate-bounce"
          data-component-path="client/src/components/Hero.jsx"
          data-component-line="11:9"
          data-component-id="client/src/components/Hero.jsx:11:9"
        >
          <ChevronDown 
            className="w-8 h-8 text-slate-500"
            data-component-path="client/src/components/Hero.jsx"
            data-component-line="12:11"
            data-component-id="client/src/components/Hero.jsx:12:11"
          />
        </div>
      </div>

      <style jsx>{`
        @keyframes fade-in {
          from {
            opacity: 0;
            transform: translateY(20px);
          }
          to {
            opacity: 1;
            transform: translateY(0);
          }
        }
        .animate-fade-in {
          animation: fade-in 1s ease-out;
        }
      `}</style>
    </section>
  );
};

export default Hero;